import { Model } from "@iventis/domain-model/model/model";

/** Gets the thumbnail id and all LOD asset ids (glb file for the model) */
export function getAllModelAssetIds(model: Model): string[] {
    const lodFileIds = model.lods.flatMap((lod) => lod.files).map((file) => file.assetId);
    return [...lodFileIds, model.thumbnailAssetId];
}
